import React from 'react';
import PropTypes from "prop-types";
import {useSearchParams} from "react-router-dom";
import {useSelector} from "react-redux";

function Preview({mode}) {
    const [searchParams] = useSearchParams();
    const responses = useSelector(state => state.responses);
    const response_points = useSelector(state => state.response_points);
    const question_practice_skills = useSelector(state => state.question_practice_skills);
    const questions = useSelector(state => state.questions).filter(question => question_practice_skills.map(qps => qps.question_code).includes(question.code));
    const schedule = useSelector(state => state.lesson_scoring_schedule);
    const practice_skills = useSelector(state => state.practice_skills);

    function renderScore(response_point, max_points) {
        if (!response_point) {
            return (
                <div className='badge bg-warning'>NR</div>
            );
        } else {
            if (response_point.points !== null) {
                let color = '';
                if (response_point.use_auto === 'using_ai') {
                    color = 'badge bg-blue'
                } else if (response_point.use_auto === 'using') {
                    color = 'badge bg-grey'
                } else if (response_point.use_auto === 'using_attempt') {
                    color = 'badge bg-attempt'
                }
                if (response_point.points > max_points) {
                    color = 'badge bg-danger'
                }

                return (
                    <div
                        className={color + ' badge text-dark'}>{response_point.points}</div>
                );
            } else {
                return (
                    <div className='badge bg-danger'>NS</div>
                );
            }
        }
    }

    function renderQuestionPracticeSkills(question, stream_id) {
        const question_practice_skills_for_question = question_practice_skills.filter(qps => qps.question_code === question.code);

        return question_practice_skills_for_question.map(question_practice_skill => {
            const response_point = response_points.find(response_point => response_point.stream_id === stream_id && response_point.question_id === question.id && response_point.practice_skill_id === question_practice_skill.practice_skill_id);
            const practice_skill = practice_skills.find(practice_skill => practice_skill.id === question_practice_skill.practice_skill_id);

            return (
                <div
                    key={question_practice_skill.id}>{practice_skill.code}: {renderScore(response_point, question_practice_skill.max_points)}</div>
            );
        });
    }

    const stream_ids = [];
    response_points.map(response_point => {
        if (!stream_ids.includes(response_point.stream_id)) {
            stream_ids.push(response_point.stream_id)
        }
    });

    if (!schedule) {
        return null;
    }

    if (questions.length > 0 && mode === 'preview') {
        return (
            <div className='section scoring'>
                <div className='container'>
                    <div className='d-flex justify-content-end flex-gap-5'>
                        <div className='d-flex flex-gap-5'>
                            <div className='badge bg-warning'>NR</div>
                            <div>No response from student</div>
                        </div>
                        <div className='d-flex flex-gap-5'>
                            <div className='badge bg-danger'>NS</div>
                            <div>Score Not Set</div>
                        </div>
                        <div className='d-flex flex-gap-5'>
                            <div className='badge bg-grey'>0</div>
                            <div>Graded by Correct Answer</div>
                        </div>
                        <div className='d-flex flex-gap-5'>
                            <div className='badge bg-blue'>0</div>
                            <div>Graded by AI</div>
                        </div>
                        <div className='d-flex flex-gap-5'>
                            <div className='badge bg-attempt'>0</div>
                            <div>Graded by Attempt</div>
                        </div>
                        <div className='d-flex flex-gap-5'>
                            <div className='badge bg-danger'>{"<score>"}</div>
                            <div>Exceeding MAX points</div>
                        </div>
                        <div className='d-flex flex-gap-5'>
                            <div className='badge bg-info'>Non-math questions are not shown here</div>
                        </div>
                    </div>
                </div>
                <div className="table-responsive">
                    <table className='table table-bordered table-sm sticky'>
                        <thead>
                        <tr>
                            <th style={{minWidth: '50px'}}>Question</th>
                            {stream_ids.map((stream_id, index) => {
                                return (
                                    <td
                                        key={stream_id}
                                    >{'Student ' + (searchParams.has('show_stream_id') ? ('ID' + stream_id) : ('#' + (index + 1)))}</td>
                                );
                            })}
                        </tr>
                        </thead>
                        <tbody>
                        {questions.map((question, index) => {
                            return (
                                <tr key={question.id}>
                                    <td>{'Q' + (question.number ? question.number : index + 1) + (question.is_bonus ? '(BONUS)' : '')}</td>
                                    {stream_ids.map(stream_id => {
                                        let response = null;
                                        const stream_responses = JSON.parse(JSON.stringify(responses)).filter(response => response.stream_id === stream_id && response.question_id === question.id).reverse();
                                        if (stream_responses.length > 0) {
                                            response = stream_responses[0];
                                        }

                                        if (response && response.data) {
                                            return (
                                                <td key={stream_id}>
                                                    {renderQuestionPracticeSkills(question, stream_id)}
                                                </td>
                                            );
                                        }

                                        return (
                                            <td key={stream_id}>
                                                <div className='badge bg-warning'>NR</div>
                                            </td>
                                        );
                                    })}
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    return null;
}

Preview.propTypes = {
    mode: PropTypes.string.isRequired,
};

export default Preview;
